import React from "react";
import TrailTable from "components/common/TrailTable/TrailTable";

interface Props {
  entityId: string | number;
}

const PagesTrailTab: React.FC<Props> = ({ entityId }) => {
  return <TrailTable entityType="page" entityId={Number(entityId)} />;
};

export default PagesTrailTab;
